import MainModel from "../../components/Models/MainModel";
import { motion } from "framer-motion";
import Image from "../../components/images/Image";
import Button from "../../components/buttons/Button";
import { getFirefoxCssFix } from "../../components/commonfunctions/getFirefoxCssFix";
import moment from "moment";

interface TransactionDetails {
  [key: string]: string | number; // Allows multiple key-value pairs
}

interface TransactionReceiptProps {
  details: TransactionDetails;
  handleClickDone: () => void;
}

export default function TransactionReceipt({
  details,
  handleClickDone,
}: TransactionReceiptProps) {
  const imageVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const headingVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  const transactionDetails = [
    "Date",
    "Transaction ID",
    "Type of Transaction",
    "Amount",
    "Parent User Code",
    "Requester User Code",
    "Wallet Type",
    "Parent Location",
    "Requester Location",
  ];

  const getDisplayValue = (label: string) => {
    switch (label) {
      case "Date":
        return  moment(details["date"]).format(
                      "DD-MM-YYYY, hh:mm A"
                    );
      case "Amount":
        return `AFA ${Number(details["amount"]).toFixed(2)}`;
      default:
        return details[label.toLowerCase().replaceAll(" ", "_")] ?? "-";
    }
  };

  return (
    <MainModel handleClose={handleClickDone}>
      <motion.div
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.4 }}
        className="flex items-center justify-center"
      >
        <Image src={"success_1"} className="" />
      </motion.div>

      <motion.h1
        variants={headingVariants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
        className="text-primary_text text-heading3 text-center pt-6"
      >
        E Top Up Requested Successfully
      </motion.h1>

      <div className="h-transactionPopupHight">
        <div
          className={`h-full border mt-8 rounded-lg overflow-x-hidden overflow-auto ${getFirefoxCssFix(
            "scroll"
          )}`}
        >
          {transactionDetails.map((label) => (
            <div key={label} className="flex justify-between p-4 border-b">
              <p className="text-title2">{label}</p>
              <p className="text-title1">{getDisplayValue(label)}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <Button
          buttonName={"Done"}
          className={`py-2.5 rounded-[6px] cursor-pointer`}
          textSize={"text-large"}
          buttonOnclick={handleClickDone}
          testId={`done`}
          loading={false}
          buttonWidth={"w-[100px] cursor-pointer"}
          buttonHight="h-[42px]"
        />
      </div>
    </MainModel>
  );
}
